import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import  {BrowserRouter} from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import { whizzAppStore, persistor } from './redux/store';
import { default as en } from './i18n/en.json';
import { default as ar } from './i18n/ar.json';
import { useDispatch ,Provider, useSelector} from 'react-redux';
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";
import { PersistGate } from 'redux-persist/integration/react';

const resources = {
  en: {
      translation: en
  },
  ar: {
      translation: ar
  }
};
const root = ReactDOM.createRoot(document.getElementById('root'));
i18next.init({
  resources,
  fallbackLng: "en",
  interpolation: {
      escapeValue: false,
  },
  compatibilityJSON:'v2'
});

root.render(
  // <BrowserRouter>
      <Provider  store={whizzAppStore}>
         <PersistGate loading={null} persistor={persistor}>
         <I18nextProvider i18n={i18next}>
         <App />
         </I18nextProvider>
         </PersistGate>
      </Provider> 
      // </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
